import { Col, Layout, Progress, Row } from 'antd';
import { User } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps } from '../common/DataView';
import { Content, Footer } from 'antd/es/layout/layout';
import { KeyOutlined, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';


export const UserCard = function (props:
    DataViewProps<User> & ClickableProps<User>
) {

    const data = props.data;
    const onClick = () => { data && props.onClick && props.onClick(data); }

    return data && (
         <Col key={data.id} xs={24} sm={24} md={12} lg={8} xl={8}>
        <Layout>
            <div className={"mig-card pointer mig-border-running "} onClick={onClick}>

                <Content>
                    <Row >
                        <Col span={24}>
                            <div className={'mig-card-content pointer'} >
                                <span className='mig-title-2'>{data.username}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: "1em" }}>
                        <Col span={24}>
                        <small className='small'>{data.email}</small>
                        </Col>
                    </Row>

                </Content>
                <Footer>
                    <Row>
                        <Col span={24}>
                            <small><KeyOutlined /> {data.id}</small>
                        </Col>

                    </Row>
                </Footer>

            </div>
        </Layout>
        </Col>
    ) || null;
}